<div role="alert" class="udex-grid udex-mx-auto mt-6">
  <dcp-generic-configurator-error
    imgPath="../../../../assets/images/homepage/binoculars.png"
    headline="homepage.error.header">
  </dcp-generic-configurator-error>
  <div role="alert" class="d-flex flex-column justify-content-center align-items-center text-center body--s text-grey">
    <div class="error-message">{{'homepage.error.line1' | cxTranslate}}</div>
    <div class="error-message">{{'homepage.error.line2' | cxTranslate}}</div>
  </div>
</div>
